"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportingYearReset = exports.reportingYearReportNotExistList = exports.reportingYearListDelete = exports.reportingYearList = exports.reportingYearFindsCurrentFiscalYearByOrgId = exports.reportingYearAdd = exports.ReportDataReportingYearSuccess = exports.ReportDataReportingYearError = void 0;
var _reportingYear = require("./reportingYear.constant");
// common success
var ReportDataReportingYearSuccess = function ReportDataReportingYearSuccess(actionType, data) {
  return {
    type: _reportingYear.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.ReportDataReportingYearSuccess = ReportDataReportingYearSuccess;
var ReportDataReportingYearError = function ReportDataReportingYearError(actionType, error) {
  return {
    type: _reportingYear.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * finds current fiscal year by orgId
 * @param payload
 * @returns api response
 * @description this function used to finds current fiscal year by orgId.
 */
exports.ReportDataReportingYearError = ReportDataReportingYearError;
var reportingYearFindsCurrentFiscalYearByOrgId = function reportingYearFindsCurrentFiscalYearByOrgId(data) {
  return {
    type: _reportingYear.actionTypes.FIND_CURRENT_FISCAL_YEAR_BY_ORGID,
    payload: data
  };
};

/**
 * report fund report data
 * @param payload
 * @returns api response
 * @description this function used to get report fund report data.
 */
exports.reportingYearFindsCurrentFiscalYearByOrgId = reportingYearFindsCurrentFiscalYearByOrgId;
var reportingYearReportNotExistList = function reportingYearReportNotExistList(data) {
  return {
    type: _reportingYear.actionTypes.REPORT_NOT_EXIST_LIST,
    payload: data
  };
};

/**
 * find
 * @param payload
 * @returns api response
 * @description this function used to get year list.
 */
exports.reportingYearReportNotExistList = reportingYearReportNotExistList;
var reportingYearList = function reportingYearList(data) {
  return {
    type: _reportingYear.actionTypes.REPORTING_YEAR_LIST,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add year.
 */
exports.reportingYearList = reportingYearList;
var reportingYearAdd = function reportingYearAdd(data) {
  return {
    type: _reportingYear.actionTypes.REPORTING_YEAR_ADD,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add year.
 */
exports.reportingYearAdd = reportingYearAdd;
var reportingYearListDelete = function reportingYearListDelete(data) {
  return {
    type: _reportingYear.actionTypes.REPORTING_YEAR_LIST_DELETE,
    payload: data
  };
};

/**
 * report reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.reportingYearListDelete = reportingYearListDelete;
var reportingYearReset = function reportingYearReset(data) {
  return {
    type: _reportingYear.actionTypes.RESET,
    payload: data
  };
};
exports.reportingYearReset = reportingYearReset;